module.exports = __webpack_public_path__ + "static/img/head2.898019e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head2.png
// module id = 0eSt
// module chunks = 1